import clsx from 'clsx';

import styles from './style.module.scss';

export const ConnectionLostError = () => (
  <div
    className={clsx(
      'd-flex',
      'justify-content-center',
      'align-items-center',
      'flex-column',
      styles.wrapper,
    )}
  >
    <h2 className={styles.title}>Connection Lost</h2>
    <p className={styles.description}>
      You are offline, please try again later.
    </p>
  </div>
);
